import { Link } from "react-router-dom";
import { PUBLIC_ROUTES } from "../../routes";
import MarketingShell from "./MarketingShell";

const CAPABILITIES = [
  {
    title: "Long-horizon planning",
    body: "The planner reasons over the world twin to draft multi-step plans — pick sequences, traversal routes, fault-recovery branches — and rehearses them in simulation first.",
  },
  {
    title: "Skill-context tuning",
    body: "Plans are tuned against your operating constraints: speed limits, exclusion zones, allowable contact, payload class.",
  },
  {
    title: "Disclosure-grade rationale",
    body: "Every plan ships with a structured rationale that is signed into the Intent Ledger before it is allowed anywhere near hardware.",
  },
] as const;

export default function ProductIntelligenceCore() {
  return (
    <MarketingShell>
      <section className="sg-hero">
        <div className="sg-hero-copy">
          <p className="sg-eyebrow">Pillar B · Cloud Intelligence Core</p>
          <h1>Plan the robot&rsquo;s next hour, not just the next step.</h1>
          <p className="sg-hero-text">
            The Intelligence Core runs on frontier language models, grounded
            in the world twin produced by Scan-to-Sim. It drafts,
            critiques, and signs off on plans before the Edge Reflex
            executes them — reasoning in the cloud over signed
            abstractions from the Local Mind, never raw video, and
            acting only through the safety layer on the robot.
          </p>
          <div className="sg-hero-actions">
            <Link to={PUBLIC_ROUTES.signup} className="sg-btn sg-btn-primary">
              Request a pilot
            </Link>
            <Link to={PUBLIC_ROUTES.productEdgeReflex} className="sg-btn sg-btn-secondary">
              See Edge Reflex
            </Link>
          </div>
        </div>
      </section>

      <section className="sg-pillars">
        <div className="sg-section-heading compact">
          <p className="sg-section-kicker">Capabilities</p>
          <h2>Reasoning, not just reflexes.</h2>
        </div>
        <div className="sg-pillars-grid">
          {CAPABILITIES.map((item) => (
            <article className="sg-pillar" key={item.title}>
              <h3>{item.title}</h3>
              <p>{item.body}</p>
            </article>
          ))}
        </div>
      </section>
    </MarketingShell>
  );
}
